var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","width":"620px"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('N_I_123')))]),_c('div',{staticClass:"left-s"},[_c('div',{style:(_vm.myChartStyle),attrs:{"id":"mounthData3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }